import React, {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, CircularProgress, Container, FormControlLabel, Grid, TextField} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {SectionService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Select from "react-select";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const SectionForm = () => {
    const methods = useForm();
    const [data, setData] = useState({});
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const [sections, setSections] = useState([]);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const {rights} = useContext(CurrentUserContext);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {
        SectionService.getRoot().then((response) => {
            setSections(response.data);
        });

        if (id !== "new") {
            SectionService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({countryDefaults: {}});
            setIsReady(true);
        }
    }, [id]);

    const {handleSubmit, control, errors} = methods;
    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            SectionService.update({...data, ...d}).then((response) => {
                showMessage('Section updated.');
            }).catch((err) => {
                showError(err.message);
            });
        } else {
            SectionService.create({...data, ...d}).then((response) => {
                setData(response.data);
                showMessage('Section Created.');
            }).catch((err) => {
                showError(err.message);
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/templates/sections')
        }, 100)   
    };

    if (!isReady) {
        return (<CircularProgress/>);
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
  
    return (
        <Container>
            <header>
                <h1>Section</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Controller disabled={!rights.includes("ROLE_SI_ADMIN")}
                            name="title"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Title"
                            color="primary"
                            rules={{required: 'Type code is required.'}}
                            variant="outlined"
                            defaultValue={data.title}
                        />
                        <ValidationError error={errors.title}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller disabled={!rights.includes("ROLE_SI_ADMIN")}
                            name="sectionOrder"
                            control={control}
                            as={TextField}
                            fullWidth
                            rules={{required: 'Type code is required.'}}
                            label="Section Order"
                            color="primary"
                            variant="outlined"
                            defaultValue={data.sectionOrder}
                        />
                        <ValidationError error={errors.sectionOrder}/>
                    </Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Parent Section"
                                          htmlFor="sectionParentId"
                                          className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                          labelPlacement="top"
                                          control={<></>}/>
                        <Controller
                            control={control}
                            name="sectionParentId"
                            fullWidth
                            color="primary"
                            variant="outlined"
                            defaultValue={data.sectionParentId}
                            render={({value, onChange}) =>
                                <Select isDisabled={!rights.includes("ROLE_SI_ADMIN")}
                                    value={sections.filter(s => s.id === value).map(v => {
                                        return {value: v.id, label: v.title}
                                    })}
                                    onChange={value => {
                                        onChange(value.value);
                                    }}
                                    options={sections.map(p => ({value: p.id, label: p.title}))}
                                />
                            }
                        />
                        <ValidationError error={errors.sectionId}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Show in Editor" variant="outlined" control={
                            <Controller
                                name="displayInEditor"
                                control={control}
                                fullWidth
                                label="Show in Editor"
                                color="primary"
                                variant="outlined"
                                defaultValue={data.displayInEditor}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox disabled={!rights.includes("ROLE_SI_ADMIN")}
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Allow Documents" variant="outlined" control={
                            <Controller
                                name="allowDocuments"
                                control={control}
                                fullWidth
                                label="Allow Documents"
                                color="primary"
                                variant="outlined"
                                defaultValue={data.allowDocuments}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox disabled={!rights.includes("ROLE_SI_ADMIN")}
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="Allow Statements" variant="outlined" control={
                            <Controller
                                name="allowStatements"
                                control={control}
                                fullWidth
                                label="Allow Statements"
                                color="primary"
                                variant="outlined"
                                defaultValue={data.allowStatements}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox disabled={!rights.includes("ROLE_SI_ADMIN")}
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>

                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit" disabled={!rights.includes("ROLE_SI_ADMIN")}>Submit</Button>
                    </Grid>
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
        </Container>
    );
};

export default SectionForm;
